import QuickSearch from './QuickSearch';

export default QuickSearch;
